import React from 'react';

export default function Forbidden() {
  // @Todo(Raj): Nice UI
  return (
    <div>
      <p style={{ fontSize: '16px' }}>You cannot access this page.</p>
    </div>
  );
};